/*#__PURE__*/ export default {"key":"eventVisualisation","type":"root","items":[{"key":"defaultSelectedTab","def":"scores","type":"string"}]};